import BaseModelAPI from '../BaseModelAPI';

export default class UserSignatureList extends BaseModelAPI {

	static entity = 'usersignaturelist'
	static entityName = 'usersignature';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
